<template>
      <!-- iq-card -->
      <b-col xs="12" sm="12" md="12" lg="12" xl="12">
        <iq-card>
          <template v-slot:body>
            <!-- application form detail -->
            <b-overlay :show="formData" rounded="sm">
              <table class="table table-bordered" v-if="data">
                  <thead class="text-white" style="background-color: #609513">
                      <tr style="background-color: #609513">
                          <th width="100px" class="text-center">{{ $t('globalTrans.sl_no') }}</th>
                          <th width="60%">{{ $t('grant_config.title_a') }}</th>
                          <th class="text-center">{{ $t('globalTrans.attachment') }}</th>
                      </tr>
                  </thead>
                  <!-- <b-tr>
                    <td>{{ $n(1) }}</td>
                    <td>{{ $t('globalTrans.application_form') }}</td>
                    <td>
                          <a target="blank" :href="url + 'download-attachment?file=uploads/application_form/original/' + data.attachment" title="Application Form">{{ data.attachment }} <i class="ri-download-cloud-fill"></i></a>
                    </td>
                  </b-tr> -->
                  <b-tr v-for="(item, index) in data.details" :key="index">
                      <td class="text-center">{{ $n(index + 1) }}</td>
                      <td>{{item.title}}</td>
                      <td class="text-center">
                      <!-- <a target="blank" :href="url + 'download-attachment?file=uploads/application_form/original/' + item.attachment" title="Application Form">{{ item.attachment }} <i class="ri-download-cloud-fill"></i></a> -->
                      <a target="_blank" class="btn btn-success btn-sm" :href="url + 'storage/application_form/original/' + item.attachment">{{ $t('globalTrans.download') }} <i class="ri-download-cloud-fill" style="font-size: 15px"></i></a>
                      </td>
                  </b-tr>
              </table>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
</template>
<script>
import { grantAllowanceServiceBaseUrl } from '@/config/api_config'
export default {
    props: ['data'],
    data () {
        return {
            formData: false,
            app_form_data: {},
            url: grantAllowanceServiceBaseUrl
        }
    },
    created () {
      this.formData = true
      if (this.data != null) {
        this.formData = false
      } else {
        this.formData = false
      }
    },
    computed: {
      currentLocale: function () {
        return this.$i18n.locale
      }
    }
}
</script>
